module.exports = __webpack_public_path__ + "b1.c0a3aa14c1d4db955e86195fe4ad9fb3.png";